//nav-mobile-trigger

var hornstrup = hornstrup || {};

hornstrup.breadcrumb = hornstrup.breadcrumb || function () {
    var self = this;
    var objSectionClasses = {
        'breadcrumbNormal'                         : ['facts','list2','list3','list4','header1','header2','cta','lead-text','author-and-share','text-content','embed-media','image-text-page'],
        'breadcrumbPositionAbsoluteTop'            : ['mosaic','statement','usp'],
        'breadcrumbPositionAbsoluteTop50Percent'   : ['focusarea'],
        'breadcrumbNone'                           : ['hero','search-page'],
        'breadcrumbBelowFirstElement'              : ['image-full']
    };

    this.placeIt = function (callback) {
        if($('#breadcrumb').length){
            var breadcrumb = $('#breadcrumb');
            var contentContainer = $('#content');

            var firstSectionFirstClass=self.getClassNameOfFirstSection();
            var typeOfFirstSection = self.getTypeOfFirstSection(firstSectionFirstClass);



            switch (typeOfFirstSection){
                case 'breadcrumbPositionAbsoluteTop':
                    $(contentContainer).prepend($(breadcrumb));
                    $(breadcrumb).addClass('breadcrumb--pos-abs')
                    break;
                case 'breadcrumbPositionAbsoluteTop50Percent':
                    $(contentContainer).prepend($(breadcrumb));
                    $(breadcrumb).addClass('breadcrumb--pos-abs');
                    $(breadcrumb).addClass('breadcrumb--50percent');
                    break;
                case 'breadcrumbNone':
                    $(breadcrumb).remove();
                    break;
                case 'breadcrumbBelowFirstElement':
                    $('.'+firstSectionFirstClass).first().after($(breadcrumb));
                    $(breadcrumb).addClass('breadcrumb--2nd');
                break;
                case 'breadcrumbNormal':
                    $(contentContainer).prepend($(breadcrumb));
                    break;
            }



        }


    }
    this.getTypeOfFirstSection = function (firstSectionFirstClass) {

        var result = '';

            for (var key in objSectionClasses) {
                if(objSectionClasses[key].indexOf(firstSectionFirstClass) != -1){
                    result = key;
                }
            }

            if(result == ''){
                cl('error: missing first section type in objSectionClasses');
                result = 'breadcrumbNormal';
            }
            return result;
    }
    this.getClassNameOfFirstSection = function (callback) {
         var firstSectionInContent = $('#content > section:not(.breadcrumb)').first();
         return $(firstSectionInContent).attr('class').split(' ')[0];
    }

    // public functions:
    return {
        placeIt: placeIt
    };
}();